// Unpublished Work © 2020-2024 Deere & Company.

export default {
    '3': 1200,
    '2': 767,
    '1': 0
};
